import "./CompareGroup.scss";

import React from "react";

import {
  Box,
  Grid2,
  Typography
} from "@mui/material";

import { CompareGroupContent } from "../../models/app-data-model";
import CompareGrid from "../compare-grid/CompareGrid";
import RichTextBlock from "../rich-text-block/RichTextBlock";

export type CompareGroupProps = {
  content: CompareGroupContent;
};

const CompareGroup: React.FC<CompareGroupProps> = ({ content }) => {
  const compareGridRows = content.included_grids.map((grid, index) => <CompareGrid grid={grid.compare_grid} key={index} />)
  return <Box className='compare-group'>
    {content.title && <h3 className="compare-title">{ content.title}</h3>}
    {content.description && <Typography component="div" className="compare-description">
      <RichTextBlock content={content.description} />
    </Typography>}
    {compareGridRows && <Grid2 container className="compare-grids">
      {compareGridRows}
    </Grid2>}
  </Box>;
};

export default CompareGroup;
